module.exports = __webpack_public_path__ + "media/9-Shernelle_Charles_Testimonial.63ea5ea3.mp3";